import { AuthLayout } from '@/components/auth-layout';
import { useSignOut, useViewer } from '@/features/session';
import { Button } from '@/shared/ui/button';
import { WelcomeForm } from './welcome-form';

/** New account: name the workspace (design: Auth, workspace). */
export function WelcomePanel() {
  const { viewer } = useViewer();
  const { signOut } = useSignOut();
  if (!viewer) return null;

  return (
    <AuthLayout viewKey="workspace">
      <div data-enter="" className="flex flex-col gap-2">
        <span className="text-meta text-muted">Signed in as {viewer.user.email}</span>
        <h1 className="font-semibold text-title-lg">Name your workspace</h1>
        <p className="text-muted">
          Your plan, Pod-hours and invoices belong to the workspace. You can rename it later.
        </p>
      </div>
      <WelcomeForm email={viewer.user.email} suggestedName={viewer.suggestedWorkspaceName} />
      <p data-enter="" className="text-meta text-muted">
        Not you?{' '}
        <Button variant="link" size="inline" onClick={() => void signOut()}>
          Sign out
        </Button>
      </p>
    </AuthLayout>
  );
}
